// Import: Middleware Action & Custom Types
import {
  CLEAN_ASSIGMENTS_ORDER_REMOVE_DOCUMENT,
  CLEAN_ASSIGMENTS_ORDER_REMOVE_DOCUMENT_ERROR,
} from '_models/redux/types';

// Action function
export const cleanRemoveAssignmentDocument = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_ASSIGMENTS_ORDER_REMOVE_DOCUMENT,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_ASSIGMENTS_ORDER_REMOVE_DOCUMENT_ERROR,
    });
  }
};
